(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/my-profile-react/assets/react/pages/notifications/notifications-syndicate-service.js') >= 0) return;  svs.modules.push('/modules/my-profile-react/assets/react/pages/notifications/notifications-syndicate-service.js');
'use strict';

const {
  jupiter
} = svs.core;

const getSyndicateDataAsync = async () => {
  svs.myProfile.logger.debug('CommunicationSettingsSyndicateService:getSyndicateDataAsync start...');
  let syndicateNotificationSettings = {};
  try {
    const {
      response,
      status
    } = await jupiter.callAsync({
      method: 'GET',
      path: '/marketplace/1/notificationsettings'
    });
    svs.myProfile.logger.debug("getSyndicateDataAsync:notificationsettings status ".concat(status));
    syndicateNotificationSettings = response.notificationSettings;
  } catch (error) {
    svs.myProfile.logger.error('getSyndicateDataAsync:notificationsettings error:', error);
    return {
      status: 'error',
      error
    };
  }
  return {
    status: 'success',
    syndicateNotificationSettings
  };
};

const putCustomersSyndicateAsync = async function (notification) {
  let c = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  let i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  try {
    svs.myProfile.logger.debug('putCustomersSyndicateAsync notifications:', notification);
    let path = '/marketplace/1/notificationsettings';
    const data = {
      notificationSettings: notification
    };
    if (c !== '' && i !== '') {
      path = "/marketplace/1/notificationsettingsbyguid/".concat(i, "?guid=").concat(c);
    }
    const response = await jupiter.callAsync({
      method: 'PUT',
      path,
      data
    });
    if (response !== null && response !== void 0 && response.error) {
      svs.myProfile.logger.error('putCustomersSyndicateAsync error response from jupiter:', response.error);
      return {
        status: 'error',
        error: response.error
      };
    }
    svs.myProfile.logger.debug('putCustomersSyndicateAsync response from jupiter');
    return {
      status: 'success'
    };
  } catch (err) {
    svs.myProfile.logger.error('putCustomersSyndicateAsync error from jupiter:', err);
    return {
      status: 'error',
      error: err
    };
  }
};
svs.myProfile.react.pages.notifications.notificationsSyndicateService = {
  getSyndicateDataAsync,
  putCustomersSyndicateAsync
};

 })(window);